import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/src/node_modules/next/dist/client/image-component.js");
